import { autoUpdate, computePosition, flip, shift } from "@floating-ui/react-dom";
import { posToDOMRect } from "@tiptap/react";
const updateFloatingPosition = (editor, element, zIndex = 9999) => {
  const virtualElement = {
    getBoundingClientRect: () => posToDOMRect(editor.view, editor.state.selection.from, editor.state.selection.to)
  };
  computePosition(virtualElement, element, {
    placement: "bottom-start",
    strategy: "absolute",
    middleware: [shift(), flip()]
  }).then(({ x, y, strategy }) => {
    element.style.width = "max-content";
    element.style.position = strategy;
    element.style.left = `${x}px`;
    element.style.top = `${y}px`;
    element.style.zIndex = `${zIndex}`;
  });
};
const anchorToSelection = (editor, renderer, zIndex) => {
  const element = renderer.element;
  return autoUpdate(
    {
      getBoundingClientRect: () => posToDOMRect(editor.view, editor.state.selection.from, editor.state.selection.to),
      contextElement: editor.view.dom
    },
    element,
    () => updateFloatingPosition(editor, element, zIndex)
  );
};
export {
  anchorToSelection,
  updateFloatingPosition
};
//# sourceMappingURL=floating-ui-utils.js.map
